import getResponse from './getResponse'

const fetch = async (path: string, returnResponse = false) => {
  const response = await getResponse(path)

  return returnResponse ? response : response.json()
}

export default fetch
